import { PHYSICS } from '../../config/settings';
import { MoveContext, MovementState } from './MovementState';

/** Falling or swinging: gravity plus gentle air steering. Web constraints are
 *  applied separately by the controller, so a swing is just "airborne with a
 *  rope". */
export class AirborneState implements MovementState {
  readonly name = 'airborne';

  update({ player, wish, moving, dt }: MoveContext): void {
    player.velocity.y -= PHYSICS.GRAVITY * dt;
    if (moving) {
      player.velocity.x += wish.x * PHYSICS.AIR_ACCEL * dt;
      player.velocity.z += wish.z * PHYSICS.AIR_ACCEL * dt;
    }
  }
}
